import { render, staticRenderFns } from "./EditGoods/template.html?vue&type=template&id=dad85d46&scoped=true&"
import script from "./EditGoods/script.ts?vue&type=script&lang=js&"
export * from "./EditGoods/script.ts?vue&type=script&lang=js&"
import style0 from "./EditGoods/style.scss?vue&type=style&index=0&id=dad85d46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad85d46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
